module.exports = __webpack_public_path__ + "img/bg-1.73bb3538.jpg";